import { env } from '../env.utils';

export const API_BASE_URL = env('VITE_API_URL');
export const COMMON_HEADERS = {
  Accept: 'application/json,*/*',
  'application-id': env('VITE_HEADER_APPLICATION_ID'),
};
export const HEADER_APPLICATION_KEY = 'Gtm-Application-Id' as const;
